export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Hold Reason\",\n    \"label_plural\": \"{{count}} Hold Reasons\"\n}\n"